import { render, staticRenderFns } from "./AlarmRecords.vue?vue&type=template&id=b253f5e8&scoped=true"
import script from "./AlarmRecords.vue?vue&type=script&lang=js"
export * from "./AlarmRecords.vue?vue&type=script&lang=js"
import style0 from "./AlarmRecords.vue?vue&type=style&index=0&id=b253f5e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b253f5e8",
  null
  
)

export default component.exports